import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory } from "react-router-dom";
import { DigitalWaiversSettings } from "../../components/Customers/DigitalWaivers/DigitalWaiversSettings";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { Page } from "../Page";

export const DigitalWaiversSettingsPage = () => {
    const history = useHistory();
    const handleClick = () => {
        history.push("/customers/digitalWaivers");
    };

    return (
        <Page title="Digital Waivers Settings">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="mr-auto">
                        <Breadcrumb.Item>Customers</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Digital Waivers</Breadcrumb.Item>
                        <Breadcrumb.Item>Settings</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                </HeaderToolbar>

                <ColumnLayout.Fill>
                    <DigitalWaiversSettings />
                </ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
